import { Component, OnInit } from '@angular/core';
import { AbstractDataProvider } from '../../AbstractDataProvider';
import { forkJoin } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { GenericFilterModel, QueryStringParam } from 'src/app/security/QueryStringParam';
import {
  AnnouncementModel,
  Contacts,
  DataItemModel,
} from '../../../shared/model/interfaces';
import {extractContacts, getErrorMessageText} from '../../helper';

@Component({
  selector: 'app-investor-home',
  templateUrl: './investor-home.component.html',
  styleUrls: ['./investor-home.component.css']
})
export class InvestorHomeComponent implements OnInit {

  public forms: DataItemModel[] = [];
  public statements: DataItemModel[] = [];
  public taxes: DataItemModel[] = [];
  public communications: DataItemModel[] = [];
  public confirms: DataItemModel[] = [];

  public investor: any;

  public Announcements: AnnouncementModel[] = [];
  public OwnerShipType = '-';
  public CustodianAccNum = '-';
  public contacts: Contacts;
  display = false;
  alertmessage: string;
  InboxCount = 0;

  public differentLoggedIn: boolean;

  constructor(
    private abstractDataProvider: AbstractDataProvider,
    private ngxService: NgxUiLoaderService,
    private authService: AuthServiceCustom) {
  }

  ngOnInit() {
    this.differentLoggedIn = this.authService.DifferentLoggedIn;
    // this.ngxService.start();
    const genericFilterModel = new GenericFilterModel();
    genericFilterModel.Filters = [];

    genericFilterModel.PageNo = 0;
    genericFilterModel.PageSize = 3;
    genericFilterModel.SortField = '';
    genericFilterModel.SortOrder = '';
    genericFilterModel.SkipRecords = 0;
    genericFilterModel.Filters.push({Key: 'forWhat', Value: 'announcement'});
    genericFilterModel.Filters.push({Key: 'daysToGoBack', Value: 'P6M'});

    const genericFilterModelStatement = new GenericFilterModel();
    genericFilterModelStatement.Filters = [];
    genericFilterModelStatement.PageNo = 0;
    genericFilterModelStatement.PageSize = 0;
    genericFilterModelStatement.SortField = 'StatementDate';
    genericFilterModelStatement.SortOrder = 'desc';
    genericFilterModelStatement.SkipRecords = 0;

    forkJoin(
      this.abstractDataProvider.postData(genericFilterModel, 'api/Form/GetForm'),
      this.abstractDataProvider.postData(genericFilterModelStatement, 'api/Statement/GetStatement'),
      this.abstractDataProvider.getData('api/Investment/GetInvestorHomePageInfo'),
      this.abstractDataProvider.postData(genericFilterModel, 'api/Inbox/GetNewMessageCount'),
      this.abstractDataProvider.postData(genericFilterModel, 'api/Inbox/GetInbox'),
    ).subscribe(([forms, statment, investment, inbox, announcement]) => {
        this.ngxService.stop();

        this.investor = investment;

        this.OwnerShipType = investment.OwnerShipType;
        this.CustodianAccNum = investment.CustodianAccNum;

        this.contacts = extractContacts(investment);

        this.forms = forms.Data.slice(0, 4);
        this.statements = statment.Statements.slice(0, 2);
        this.taxes = statment.Tax.slice(0, 2);
        this.communications = statment.Communications.slice(0, 2);
        this.confirms = statment.Confirms.slice(0, 2);
        this.InboxCount = inbox.InboxCount;
        this.Announcements = announcement.Data;
      },
      error => {
        this.ngxService.stop();
        this.display = true;
        this.alertmessage =  getErrorMessageText(error);

      });
  }


  public downloadDocumentDynamic(FundId: any, Year: any, InvestorNum: any, FileType: any): void {
    const queryParam: QueryStringParam[] = [
      {Key: 'cboFundId', Value: FundId},
      {Key: 'cboTaxYear', Value: Year + ''},
      {Key: 'txtFax', Value: ''},
      {Key: 'chkMaskTaxId', Value: 'true'},
      {Key: 'chkFaxFlag', Value: 'false'},

      {Key: 'InvestorNum', Value: InvestorNum},
      {Key: 'cboTaxType', Value: FileType}
    ];
    const is1099 = ['1099DIV', '1099B', '1099INT', '1099OID'].includes(FileType);
    const apiUrl = is1099
      ? 'api/Tax/GenerateDynamicTax1099'
      : 'api/Tax/GenerateDynamicTaxK1';

    this.abstractDataProvider.postData(queryParam, apiUrl).subscribe(
      posts => {
        if (posts.Data.url) {
          // window.open(this.abstractDataProvider.baseUrl + posts.Data.url, '_blank');
          const url = this.abstractDataProvider.baseUrl + posts.Data.url;
            this.abstractDataProvider.downloadFile(url)
            .subscribe(_ => {}, error =>{
              // TODO
            });
        } else if (posts.Data.AlertMsgs.length > 0) {
          // TODO: implement
        }
      },
      error => {
        // TODO: implement
      }
    );
  }

  onConfirm() {
    this.display = false;
  }


  navigateToUnReadMsg() {
    this.authService.navigateToUrl('inbox', {mode: 'unread'});
  }

}
